<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 115.262 122.881"
    enable-background="new 0 0 115.262 122.881"
    xml:space="preserve"
  >
    <g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.368,56.996h64.875V37.337H69.574c-2.17,0-5.189-1.17-6.619-2.6 s-2.301-4.01-2.301-6.169V7.64l0,0H8.139c-0.18,0-0.32,0.09-0.41,0.18c-0.15,0.1-0.19,0.23-0.19,0.42v106.442 c0,0.14,0.09,0.319,0.18,0.409c0.09,0.141,0.28,0.181,0.41,0.181c22.778,0,58.086,0,81.504,0c0.18,0,0.17-0.091,0.27-0.181 c0.141-0.09,0.33-0.279,0.33-0.409v-11.159H25.368c-4.139,0-7.56-3.4-7.56-7.56V64.545C17.808,60.396,21.208,56.996,25.368,56.996 L25.368,56.996L25.368,56.996z M30.584,67.946h11.42c2.247,0,4.069,0.306,5.453,0.913c1.383,0.613,2.531,1.488,3.438,2.628 c0.904,1.147,1.558,2.473,1.962,3.988c0.412,1.517,0.615,3.121,0.615,4.816c0,2.656-0.302,4.717-0.91,6.182 c-0.602,1.465-1.441,2.691-2.517,3.683c-1.078,0.988-2.229,1.648-3.462,1.979c-1.685,0.451-3.214,0.677-4.58,0.677h-11.42V67.946 L30.584,67.946z M38.26,73.571v13.58h1.886c1.61,0,2.756-0.179,3.439-0.532c0.677-0.358,1.209-0.978,1.598-1.863 c0.387-0.893,0.579-2.328,0.579-4.319c0-2.634-0.43-4.433-1.291-5.406c-0.863-0.972-2.293-1.459-4.29-1.459H38.26L38.26,73.571z M55.31,67.946h8.474l4.406,7.65l4.277-7.65h8.369l-7.727,12.045l8.457,12.821h-8.648l-4.881-7.987l-4.914,7.987h-8.578 l8.572-12.96L55.31,67.946L55.31,67.946z M83.578,67.946h18.998v5.349H91.289v4.34h9.656v5.037h-9.656v10.141h-7.711V67.946 L83.578,67.946z M97.771,56.996h9.93c4.16,0,7.561,3.41,7.561,7.559v31.418c0,4.149-3.41,7.56-7.561,7.56h-9.93v13.549 c0,1.609-0.648,3.039-1.699,4.1c-1.061,1.06-2.49,1.7-4.1,1.7c-29.438,0-56.585,0-86.173,0c-1.61,0-3.04-0.641-4.1-1.7 c-1.06-1.061-1.7-2.49-1.7-4.1V5.85c0-1.61,0.65-3.04,1.7-4.1c1.06-1.06,2.53-1.7,4.1-1.7h58.716C64.645,0,64.785,0,64.924,0 c0.641,0,1.291,0.28,1.75,0.69h0.09c0.09,0.05,0.141,0.09,0.23,0.18l29.988,30.357c0.51,0.51,0.879,1.2,0.879,1.98 c0,0.23-0.049,0.41-0.09,0.65V56.996L97.771,56.996L97.771,56.996z M67.504,27.968V8.939l21.43,21.698h-18.76 c-0.74,0-1.379-0.32-1.889-0.78C67.824,29.398,67.504,28.708,67.504,27.968L67.504,27.968L67.504,27.968z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "DXF",
};
</script>

<style>
</style>